export default "__VITE_ASSET__CYLb7cN1__"